@if (operationContainer.currentOperation.$$showOperationView) {
  <div class="dialog operation-view-dialog">
    <div
      mat-dialog-title
      class="modal-header"
    >
      <h1 class="modal-title">
        <span>
          {{dialogTitle}}
        </span>
      </h1>

      <button
        type="button"
        mat-icon-button
        class="close"
        [tabindex]="-1"
        aria-label="close dialog"
        mat-dialog-close=""
      >
        <mat-icon>
          close
        </mat-icon>
      </button>
    </div>

    <div
      mat-dialog-content
      class="modal-body modal-body-edit-fields"
    >
      <div class="modal-main-content">
        <app-operation-view-information
          [operationContainer]="operationContainer"
          [operationStepIndex]="operationContainer.currentOperation.$$currentStepIndex"
        ></app-operation-view-information>

        @if (hasObjectsInPackage()) {
          <div class="operation-view-dialog__warning-container">
            <mat-icon class="operation-view-dialog__warning-icon">
              warning
            </mat-icon>
            <span>
              <span class="bold">
                {{ 'TRANS__OPERATIONS__LOCATION_PACKAGE__WARNING' | translate }}
              </span>

              {{ 'TRANS__OPERATIONS__LOCATION_PACKAGE__WARNING_DESCRIPTION' | translate }}
            </span>
          </div>
        }

        @if (!operationContainer.currentOperation.upload_info) {
          <app-operation-view-section-container
            [operationContainer]="operationContainer"
            [operationStepIndex]="operationContainer.currentOperation.$$currentStepIndex"
            [isDialog]="true"
            [isLocationOperation]="hasObjectsInPackage()"
          ></app-operation-view-section-container>
        }
        @else {
          <app-operation-view-upload
            [operationContainer]="operationContainer"
            [operationStepIndex]="operationContainer.currentOperation.$$currentStepIndex"
          ></app-operation-view-upload>
        }

        @if (operationStepExecutionResult && operationStepExecutionResult.status === 'failed') {
          <div class="operation-view-dialog__failed">
            @for (errorMessage of errorMessages; track $index) {
              <span>
              {{errorMessage | translate}}
            </span>
            }
          </div>
        }
      </div>
    </div>

    <div
      mat-dialog-actions
      class="modal-footer"
    >
      <app-operation-toolbar-dialog
        class="operation-view-dialog__toolbar_container"
        [hasPackageObjects]="hasObjectsInPackage()"
        [operationContainer]="operationContainer"
        [operationStep]="operationContainer.currentOperation.$$currentStep"
        [selectorEnabled]="operationContainer.selectorEnabled"
        (operationStepExecutionResult)="onOperationStepExecutionResult($event)"
      ></app-operation-toolbar-dialog>
    </div>
  </div>
}
